import React from "react"
import Showcase from "../components/Showcase"
import {
  View,
  Text,
  Touchable,
  ProgressIndicator,
  Image,
} from "react-ame-components"

export class BulletExample extends React.Component {
  state = {
    selected: 1,
    bullets: 5,
  }

  previous = () => {
    this.state.selected > 1 &&
      this.setState(state => ({
        selected: state.selected - 1,
      }))
  }

  next = () => {
    this.state.selected < this.state.bullets &&
      this.setState(state => ({
        selected: state.selected + 1,
      }))
  }

  render() {
    return (
      <Showcase
        title="Componente Bullet"
        description="Este componente serve para indicar a etapa de algum progresso">
        <View
          justify="center"
          marginTop="xs">
          <ProgressIndicator
            returnSelected={index => console.log(index)}
            bullets={this.state.bullets}
            selected={this.state.selected}
          />
        </View>
        <View
          justify="center"
          marginTop="xs">
          <Text
            textAlign="center"
            fontSize="jumbo">
            {this.state.selected}
          </Text>
        </View>
        <View
          justify="center"
          marginTop="xs">
          <Touchable onClick={() => this.previous()}>
            <Image icon="left-previous" />
          </Touchable>
          <Touchable onClick={() => this.next()}>
            <Image icon="right-next" />
          </Touchable>
        </View>
      </Showcase>
    )
  }
}
